import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const listWorkflowTemplateAutomations = gql`
  query ListWorkflowTemplateAutomationsQuery($input: ListWorkflowTemplateAutomations!) {
    listWorkflowTemplateAutomations(input: $input) {
      automations {
        ...Automation
      }
      hasMore
    }
  }

  ${Fragments.automation.Automation}
`;

export const getAutomation = gql`
  query GetAutomationQuery($id: UUID!) {
    getAutomation(id: $id) {
      ...Automation
    }
  }

  ${Fragments.automation.Automation}
`;
